import { BaseAdapter } from './base.adapter';
import type { RecommendationConfig, RecommendationSelection, RecommendationOption } from '@/types';
export interface RecommendationOptionsResponseDto {
  options: Array<{ id: string; label: string; blocked?: boolean; imageUrl?: string; sku?: string }>;
  nextCursor: string | null;
}
export interface ProductRecommendationResponseDto {
  promoted: RecommendationSelection;
  excluded: RecommendationSelection;
  revision?: number;
  syncStatus?: 'pending' | 'synced';
}
export class ProductRecommendationAdapter extends BaseAdapter {
  static optionsFromApi(dto: RecommendationOptionsResponseDto): { options: RecommendationOption[]; nextCursor: string | null } {
    return { options: dto.options.map((row) => ({ id: row.id, label: row.label, blocked: row.blocked, imageUrl: row.imageUrl, sku: row.sku })), nextCursor: dto.nextCursor };
  }
  static fromApi(dto: ProductRecommendationResponseDto): RecommendationConfig {
    const selection = (value: RecommendationSelection): RecommendationSelection => ({
      productIds: [...value.productIds], tags: [...value.tags], collectionIds: [...value.collectionIds], prompts: value.prompts?.map((prompt) => ({ kind: prompt.kind, id: prompt.id, instruction: prompt.instruction })),
    });
    return { promoted: selection(dto.promoted), excluded: selection(dto.excluded), revision: dto.revision, syncStatus: dto.syncStatus };
  }
}
